import request from "../request";

/**
 * @return {Promise<{ result: URL<String> }>}
 */
export const devLogin = () => {
    return request({
        url:'/user/security/dev-login',
        type: "GET",
    })
}